var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSharing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd07a374-3e6f-42a2-9797-b4c46f208564",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a190aac0-f345-4673-958f-c58589d82782 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a190aac0-f345-4673-958f-c58589d82782",
    d: "M58.2,8.5H33.787A1.982,1.982,0,0,0,31.81,10.49V49.51A1.983,1.983,0,0,0,33.787,51.5H66.213A1.983,1.983,0,0,0,68.19,49.51V18.543Zm6.986,40H34.81v-37H56.956l8.234,8.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a190aac0-f345-4673-958f-c58589d82782",
    d: "M51.5,21.624a1.5,1.5,0,1,0-3,0V28.5H41.623a1.5,1.5,0,1,0,0,3H48.5v6.877a1.5,1.5,0,1,0,3,0V31.5h6.877a1.5,1.5,0,1,0,0-3H51.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSharing);
export default __webpack_public_path__ + "static/media/FileSharing.91e26d8d366253d218aacc37d811af79.svg";
export { ForwardRef as ReactComponent };